import React from 'react';

import {
  BaseWidget,
  LabelledText
} from 'modules';
import {
  Link,
  styled
} from '@mui/material';

import * as dataService from './dataService';



const LabelImg = styled('img')(() => ({
  maxHeight: '128px',
  maxWidth: '128px'
}));



export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);



  return (
    <BaseWidget.FC title="Return Shipping">
      <LabelledText.FC
        title="Tracking Number"
        text={(
          <Link
            href={queryTuple.data.trackingUrl}
            target="_blank">
            {queryTuple.data.trackingNumber}
          </Link>
        )} />

      <Link
        href={queryTuple.data.labelUrl}
        target="_blank">
        <LabelImg src={queryTuple.data.labelUrl} />
      </Link>
    </BaseWidget.FC>
  );
};
